import React, { useMemo } from "react";

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectWorkQueue } from "../../../lib/workQueueNavigation";

export default function WorkQsListWithChildren({ list, setIsListOpened, classes }) {
    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);
    const dispatch = useDispatch();

    const handleQueueLinkClick = (item) => {
        selectWorkQueue(dispatch, item);
        if (setIsListOpened) {
            setIsListOpened(false);
        }
    };

    const parentItemsByGroup = useMemo(() => {
        if (!list) return [];
        return list
            .map((group) => {
                const wq = group.workQs || [];
                const parents = wq.filter((item) => item.parent_id == null);
                // Group only lists child queues (parent row not in this group): still show them in the menu
                const usedFallback = parents.length === 0 && wq.length > 0;
                const parentItems = usedFallback ? wq : parents;
                return {
                    groupId: group.id,
                    groupName: group.name,
                    parentItems,
                    showGroupLabel:
                        usedFallback && group.id !== "undetermined" && !!group.name,
                };
            })
            .filter((g) => g.parentItems.length > 0);
    }, [list]);

    const childrenByParentId = useMemo(() => {
        const map = new Map();
        if (!list) return map;
        list.forEach((group) => {
            (group.workQs || []).forEach((item) => {
                if (item.parent_id == null) return;
                const existing = map.get(item.parent_id) || [];
                map.set(item.parent_id, [...existing, item]);
            });
        });
        return map;
    }, [list]);

    if (!list) return null;

    return (
        <div className={classes.modal_last_cases}>
            <div className={classes.sub_menu}>
                {parentItemsByGroup.map((group) => (
                    <React.Fragment key={group.groupId}>
                        <div className={classes.group_item}>
                            {group.showGroupLabel && (
                                <div className={classes.queues_menu_group_label}>{group.groupName}</div>
                            )}
                            {group.parentItems.map((item) => (
                                <React.Fragment key={item.id}>
                                    <div className={classes.sub_menu_item} data-id={item.id}>
                                        <Link
                                            to={`/work-queues/${item.slug}`}
                                            onClick={() => handleQueueLinkClick(item)}
                                            className={`${selectedWorkQueue?.slug == item.slug ? classes.active_item : ""} ${classes.sub_menu_item_button}`}
                                        >
                                            {item.name}
                                        </Link>
                                    </div>
                                    {(childrenByParentId.get(item.id) || []).map((child) => (
                                        <div
                                            key={`child-${child.id}`}
                                            className={`${classes.sub_menu_item} ${classes.sub_menu_item_child}`}
                                            data-id={child.id}
                                        >
                                            <Link
                                                to={`/work-queues/${child.slug}`}
                                                onClick={() => handleQueueLinkClick(child)}
                                                className={`${selectedWorkQueue?.slug == child.slug ? classes.active_item : ""} ${classes.sub_menu_item_button}`}
                                            >
                                                {child.name}
                                            </Link>
                                        </div>
                                    ))}
                                </React.Fragment>
                            ))}
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}
